import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  Directive,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ModalController,
  App,
  NavController,
  ToastController,
  ViewController,
} from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../../environments/environment';
import { ConfigProvider } from '../../../providers/config/config';
import { Capacitor } from '@capacitor/core';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';

declare let CmKit: any;

@Component({
  selector: 'lc-message',
  templateUrl: 'message.html',
})
export class LCMessageComponent {
  log = debug('app:LCMessageComponent');

  @ViewChild('replyOptions') replyOptions;
  @ViewChild('emojiModal') emojiModal;

  @Output() longPress = new EventEmitter<void>();

  @Input() conversation: {} = {};
  @Input() message: any = {};
  @Input() showMedia: boolean = true;
  @Input() user_id: string = '';
  @Input() showEngagementOptions: boolean = true;
  @Input() showEmojiSelectIcon: boolean = true;
  @Input() showDate: boolean = true;
  @Input() feedSpeedBump = false;
  @Input() fullWidth = false;
  @Input() isInset = false;
  @Input() reply = false;
  @Input() messageIndex: number = 0;
  @Input() messageRepliesCount = 0;
  @Input() reactionsSize = 0;
  @Input() allowLongPress = true;
  @Input() pollMessage = false;
  scrollCloseThreshold = window.innerHeight * 4;

  replyOptionsUserName = '';
  replyOptionsAvatar = '';
  replyOptionsName = '';
  replyOptionsThankyou = false;
  muteUser = true;
  deleteTimeout = null;
  messageOffTopic = false;
  usersReportOffTopicCount = 0;
  offTopicChatIcon = 'assets/imgs/live-chat-icons/chat-bubble-crossed-out.svg';
  offTopicMessage = 'This message was marked off-topic';
  showBlueBG = false;
  votedOnPoll = false;
  link = false;
  urls = [];

  isUnAuthed = false;

  //Todo : Sending Videos

  replyInteractionFn = () => [
    [
      // {
      //   icon: 'assets/imgs/live-chat-icons/reply-interactions/profile.svg',
      //   text: 'View Profile',
      //   handler: 'viewProfile',
      // },
      // {
      //   icon: this.muteUser
      //     ? 'assets/imgs/live-chat-icons/reply-interactions/bell-blue-silence.svg'
      //     : 'assets/imgs/live-chat-icons/reply-interactions/bell-blue.svg',
      //   text: this.muteUser ? 'Unmute User' : 'Mute User',
      //   handler: this.muteUser ? 'unmuteUser' : 'muteUser',
      // },
      // {
      //   icon: 'assets/imgs/live-chat-icons/reply-interactions/block-user.svg',
      //   text: 'Block User',
      //   handler: 'blockUser',
      // },
    ],
    _.compact([
      // REPLACE once replyInteractions[0] implemented
      {
        icon: 'assets/imgs/live-chat-icons/reply-interactions/profile.svg',
        text: 'View Profile',
        handler: 'viewProfile',
      },
      // TODO - https://www.figma.com/design/y4XtzlLnUkwlRM08jrvHYk/Mobile-App---Rough-Drafts?node-id=11355-53144&t=e0822OOChpR1Je73-0
      {
        ...(this?.message?.messageId && {
          icon: 'assets/imgs/live-chat-icons/reply-interactions/curve-arrow.svg',
          text: `Reply to ${this?.message?.user?.username || ''} `,
          handler: 'replyTo',
        }),
      },
      {
        ...(_.size(this?.message?.message) && {
          icon: 'assets/imgs/live-chat-icons/reply-interactions/copy-text.svg',
          text: 'Copy Text',
          handler: 'copyText',
        }),
      },
      // {
      //   icon: 'assets/imgs/live-chat-icons/reply-interactions/copy-link.svg',
      //   text: 'Copy Link',
      //   handler: 'copyLink',
      // },
      {
        ...(this?.message?.user?._id == this.user_id && {
          icon: 'assets/imgs/live-chat-icons/reply-interactions/trash.svg',
          text: 'Delete',
          handler: 'delete',
        }),
      },
      {
        ...(!this?.message?.messageId &&
          this?.message?.user?._id !== this.user_id && {
            icon: 'assets/imgs/live-chat-icons/reply-interactions/off-topic.svg',
            text: 'Mark as Off-topic',
            handler: 'offTopic',
          }),
      },
    ]).filter(int => int?.text),
  ];
  replyInteraction;

  constructor(
    public modalCtrl: ModalController,
    public user: UserProvider,
    public appCtrl: App,
    public tools: ToolsProvider,
    public appVersion: AppVersion,
    public navCtrl: NavController,
    private env: EnvVariables,
    public configs: ConfigProvider,
    public cdr: ChangeDetectorRef,
    public liveChat: LiveChatProvider,
    public toastCtrl: ToastController,
    public viewCtrl: ViewController
  ) {}

  ngOnInit(): void {
    this.isUnAuthed = this.user.get('states.isUnauthedUser');

    if (
      this.message?.pollInformation &&
      this.message.pollInformation?.choices
    ) {
      this.pollMessage = true;
      this.checkIfUserVoted();
    }
    this.replyInteraction = this.replyInteractionFn();
    this.offTopicCheck();

    this.extractLink(this.message, 'message');
  }

  async extractLink(message, field) {
    let content = _.get(message, field);

    if (!content) return;
    this.urls = _.difference(this.findUrl(content, true, true));

    if (this.urls.length > 0) {
      this.link = true;
    }
  }

  findUrl(testUrl: string, multiple = false, trimEnd = false) {
    const urlRegex = /((?:https?:\/\/|www\.)[^\s<]+)/g;
    const matches = testUrl.match(urlRegex);

    if (multiple) {
      return matches || [];
    } else {
      return matches && matches[0];
    }
  }

  offTopicCheck() {
    if (this.message?.reports?.userIds) {
      this.usersReportOffTopicCount = _.size(this.message?.reports?.userIds);

      if (this.usersReportOffTopicCount >= 1) {
        this.message.reports.userIds.forEach(id => {
          if (id === this.user_id) {
            this.messageOffTopic = true;
          }
        });
      }

      if (this.message.reports.count > 4) {
        this.offTopicMessage =
          'This message is off topic by thecommunity. Tap to view';

        this.messageOffTopic = true;
      }
    }
  }

  navToReplies() {
    if (!this.showEmojiSelectIcon || this.viewCtrl.id === 'RepliesPage') return;
    this.log('navToReplies', this.message);
    this.navCtrl.push('RepliesPage', {
      message_id: _.get(this.message, '_id'),
      message: this.message,
      conversation: this.conversation,
    });
  }

  communityQuestion() {
    this.tools.emit('open-community-q-modal');
  }

  showOffTopicMessage() {
    this.messageOffTopic = false;
    this.showBlueBG = true;
    setTimeout(() => {
      this.showBlueBG = false;
    }, 400);
  }

  onLongPress(userId, message) {
    if (this.allowLongPress) {
      this.replyOptionsAvatar = message.user.userImage;
      this.replyOptionsName =
        message.user.firstName + ' ' + message.user.lastName;
      this.replyOptionsUserName = message.user.username;
      this.replyOptions.show();
      this.tools.logAnalyticsEvent(
        'trackCustom',
        `lc-view-message-onLongPress`
      );
    }
  }

  navToUserProfile() {
    this.replyOptions.hide();
    if (this.message?.user?._id) {
      this.tools.navTo('UserProfilePage', null, {
        user_id: this.message?.user?._id,
      });
    } else {
      this.toastCtrl.create({
        message: 'something when wrong',
        duration: 1500,
      });
    }
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-message-navToUserProfile`
    );
  }

  async userActions(type) {
    switch (type) {
      case 'viewProfile':
        this.navToUserProfile();
        break;
      case 'offTopic':
        let currentCount = this.message?.reports?.count || 0;
        let users = this.message?.reports?.users || [];
        this.messageOffTopic = true;
        this.message.reports = {
          userIds: users.push(this.user_id),
          count: currentCount++,
        };
        this.tools.logAnalyticsEvent(
          'trackCustom',
          `lc-view-message-markAsOffTopic`
        );
        this.liveChat.markAsOffTopic(this.message?._id);

        this.replyOptionsThankyou = true;

        break;
      case 'muteUser':
        this.muteUser = true;
        this.updateMuteUserOption();
        this.replyOptions.hide();
        break;
      case 'unmuteUser':
        this.muteUser = false;
        this.updateMuteUserOption();
        this.replyOptions.hide();
        break;
      case 'blockUser':
        this.replyOptions.hide();
        break;
      case 'replyTo':
        this.liveChat.emit('reply-to-reply', this.message?._id);
        this.tools.logAnalyticsEvent('trackCustom', `lc-view-message-replyTo`);
        this.replyOptions.hide();
        break;
      case 'copyText':
        this.tools.logAnalyticsEvent('trackCustom', `lc-view-message-copyText`);
        this.tools.copyToClipboard(this?.message?.message);
        this.toastCtrl
          .create({ message: 'Message copied to clipboard', duration: 1000 })
          .present();
        this.replyOptions.hide();
        break;
      case 'copyLink':
        this.replyOptions.hide();
        break;
      case 'delete':
        this.tools.logAnalyticsEvent('trackCustom', `lc-view-message-delete`);
        _.set(this.message, 'states.isDeleted', true);
        this.deleteTimeout = setTimeout(async () => {
          await this.liveChat.deleteMessageOrReply(this.message);
          _.set(this.message, 'states.isDeleted', true);
          clearTimeout(this.deleteTimeout);
          this.deleteTimeout = null;
        }, 3900);
        const toast = await this.toastCtrl.create({
          message: 'Message deleted',
          duration: 4000,
          showCloseButton: true,
          closeButtonText: 'undo',
          position: 'bottom',
        });
        toast.onDidDismiss(data => {
          if (this.deleteTimeout) {
            _.set(this.message, 'states.isDeleted', false);
          }
          clearTimeout(this.deleteTimeout);
          this.deleteTimeout = null;
        });
        toast.present();
        this.replyOptions.hide();
        break;
    }
  }

  closeThankYouRefresh() {
    this.replyOptions.hide();
  }

  updateMuteUserOption() {
    // this.replyInteraction[0][1].icon = this.muteUser
    //   ? 'assets/imgs/live-chat-icons/reply-interactions/bell-blue-silence.svg'
    //   : 'assets/imgs/live-chat-icons/reply-interactions/bell-blue.svg';
    // this.replyInteraction[0][1].text = this.muteUser
    //   ? 'Unmute User'
    //   : 'Mute User';
    this.cdr.detectChanges();
  }

  getUniqueReplies(replies: any[]) {
    const seenUserIds = new Set();
    return _.filter(replies, reply => {
      if (seenUserIds.has(reply.user._id)) {
        return false;
      } else {
        seenUserIds.add(reply.user._id);
        return true;
      }
    });
  }

  async pollVote(message, choice, index) {
    this.log('pollVote', message);
    message.pollInformation.totalVotes++;
    message.pollInformation.engagedVoters.push(this.user.info._id);
    choice.votes++;
    try {
      await this.liveChat.voteOnPoll(message?._id, message.pollInformation);
      this.votedOnPoll = true;
    } catch (e) {
      this.votedOnPoll = false;
      this.toastCtrl
        .create({
          message: e || 'Something went wrong',
          duration: 1500,
          dismissOnPageChange: true,
          position: 'bottom',
        })
        .present();
    }
  }

  checkIfUserVoted() {
    this.votedOnPoll =
      this.message?.pollInformation?.engagedVoters?.includes(
        this.user.info._id
      ) ?? false;
  }

  getMaxVotes(message): number {
    const choices = message?.pollInformation?.choices;

    if (!choices || choices.length === 0) {
      return 0;
    }

    return Math.max(...choices.map(choice => choice.votes));
  }

  roundUpPercentage(votes: number, totalVotes: number): number {
    if (totalVotes === 0) {
      return 0; // Avoid division by zero
    }
    return Math.round((votes / totalVotes) * 100);
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/message/message.ts